import AccountSettingsFeature from "../features/AccountSettings";

export default function AccountSettings() {
  return <AccountSettingsFeature />;
}
